export const createEmptyTab = () => ({
  id: Date.now(),
  name: "",
  display: "",
  src: "",
  images: [],
});

export const normalizeTags = (tag) =>
  Array.isArray(tag)
    ? tag.filter(Boolean)
    : String(tag || "")
        .split(",")
        .map((item) => item.trim())
        .filter(Boolean);

export const normalizeImages = (tab) =>
  (Array.isArray(tab.images) ? tab.images : tab.image ? [tab.image] : []).map(
    (image, index) => ({
      id: image.id || `${tab.id}-image-${index}`,
      name: image.name || "",
      data: image.data || "",
      url: image.url || "",
      description: image.description || "",
      tag: normalizeTags(image.tag).join(", "),
    }),
  );

export const parseTabs = (value) => {
  let parsed = value;
  for (
    let attempt = 0;
    typeof parsed === "string" && attempt < 2;
    attempt += 1
  ) {
    try {
      parsed = JSON.parse(parsed);
    } catch (error) {
      console.error("Failed to parse VirbrixliteLink:", error);
      return [];
    }
  }

  if (parsed && !Array.isArray(parsed) && Array.isArray(parsed.links)) {
    parsed = parsed.links;
  }

  return Array.isArray(parsed)
    ? parsed.map((tab, index) => ({
        ...tab,
        id: tab.id || `dashboard-link-${index}`,
        images: normalizeImages(tab),
      }))
    : [];
};

export const getTagColorClass = (tag) => {
  const hash = [...tag].reduce(
    (total, character) => total + character.charCodeAt(0),
    0,
  );
  return `lite-tag-color-${hash % 5}`;
};
